import { SearchTerm } from './SearchTerm';

const AccessAreaSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "areaName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
];

export default AccessAreaSearch;
